export const validatePhoneNumber = (phoneNumber: string): boolean => {
  const normalizedPhoneNumber = phoneNumber.replace(/[\s()-]/g, '');
  const match = normalizedPhoneNumber.match(/^\+\d+\D*(\d{7})$/);
  return match !== null;
};
